/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/getOrgCompliance.config.json';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { GET_COMPLIANCE_DOCS } from '../graphql';
import { VApplication } from '@/application';
import moment from 'moment-timezone';
import { useOrgId } from '../provider';

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export interface IOrgComplianceMethods extends IPluginMethodMap {
  getOrgCompliance(args: any): Promise<any>;
}

export class OrgComplianceService implements IAgentPlugin {
  readonly methods: IOrgComplianceMethods;

  constructor() {
    this.methods = {
      getOrgCompliance: this.getOrgCompliance.bind(this),
    };
  }

  async getOrgCompliance(args: any) {
    let organizationId: string;
    const { orgId } = useOrgId();
    const storageService = StorageModule?.getInstance();
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient('graphql-gateway');
    const orgDetails = storageService?.get('myProfile', 'local')?.orgData;
    const localOrgId = orgDetails?.id;
    organizationId = orgId || localOrgId;
    try {
      if (client) {
        const res = await client.query({
          query: GET_COMPLIANCE_DOCS,
          variables: {
            where: {
              id: organizationId,
            },
            options: {
              limit: args?.size ?? 10,
              offset: args?.offset ?? 0,
            },
            complianceDocsOptions2: {
              sort: [
                {
                  validUntil: 'ASC',
                },
              ],
            },
          },
          fetchPolicy: 'network-only',
        });
        if (res?.data) {
          console.log(`table data`, res);
          const tableData =
            res?.data?.orgs &&
            Array.isArray(res?.data?.orgs) &&
            res?.data?.orgs.length > 0
              ? res?.data?.orgs[0]?.complianceDocs
              : [];
          const totalCount =
            res?.data?.orgs &&
            Array.isArray(res?.data?.orgs) &&
            res?.data?.orgs.length > 0
              ? res?.data?.orgs[0]?.complianceDocsAggregate?.count
              : 0;
          let _rowData = this.formatUserTable(tableData);
          console.log(`row data`, _rowData);
          return {
            ...config,
            ultUsers: _rowData,
            isEmpty: tableData && tableData?.length <= 0,
            // studentGroup: holderGroups,
            activePage: args?.offset > 0 ? tableData / args?.offset : 1,
            pageSize: args?.size ?? 10,
            totalCount: totalCount,
            totalPages: Math.ceil(totalCount / (args?.size ?? 10)),
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  private formatUserTable(data: any) {
    console.log(`data`, data);
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any) => {
        return {
          data: item,
          id: item?.id,
          // status: item?.status,
          description: item?.description,
          name: item?.name,
          dateCreated: this.formatCreatedDate(item?.createdAt),
          image: item?.icon,
          validFrom: this.formatCreatedDate(item?.validFrom),
          validUntil: this.formatCreatedDate(item?.validUntil),
        };
      });

    return _rowData;
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format('LLL');
    } else {
      return '';
    }
  }
}
